import { createFileRoute } from "@tanstack/react-router";
import DivorceDepression from "@/pages/articles/DivorceDepression";
export const Route = createFileRoute("/divorce-and-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Divorce And Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Divorce can trigger or worsen depression. Learn how TMS, SAINT TMS, and therapy can help you recover emotionally in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Divorce And Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Divorce can trigger or worsen depression. Learn how TMS, SAINT TMS, and therapy can help you recover emotionally in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/divorce-and-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/divorce-and-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DivorceDepression />;
}
